/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Runs_EmptyInputs */

const cs_settings_automation_runs_empty = /** @type {(inputs: Settings_Automation_Runs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné běhy workflow.`)
};

const en_settings_automation_runs_empty = /** @type {(inputs: Settings_Automation_Runs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workflow runs.`)
};

/**
* | output |
* | --- |
* | "No workflow runs." |
*
* @param {Settings_Automation_Runs_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_runs_empty = /** @type {((inputs?: Settings_Automation_Runs_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Runs_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_runs_empty(inputs)
	return cs_settings_automation_runs_empty(inputs)
});